class Event {
    constructor() {
        this.bus = {}
    }
    $off(id) {
        id || delete this.bus[id];
    }
    $on(id, cb) {
        this.bus[id] = cb;
    }
    $emit(id, ...parms) {
        if (this.bus[id]) {
            this.bus[id](...parms);
        }
    }
}

export const EventBus = new Event();